/**
 * @generated SignedSource<<b7decbb036438835264651dd156ac573>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableTeamsInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type disableTeamsMutation$variables = {
  input: DisableTeamsInput;
};
export type disableTeamsMutation$data = {
  readonly disableTeams: {
    readonly company: {
      readonly teamsEnabled: boolean | null;
    } | null;
  } | null;
};
export type disableTeamsMutation = {
  variables: disableTeamsMutation$variables;
  response: disableTeamsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamsEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "disableTeamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableTeamsPayload",
        "kind": "LinkedField",
        "name": "disableTeams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "disableTeamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableTeamsPayload",
        "kind": "LinkedField",
        "name": "disableTeams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c470b94541e94fa0a584a69eefa1ea22",
    "id": null,
    "metadata": {},
    "name": "disableTeamsMutation",
    "operationKind": "mutation",
    "text": "mutation disableTeamsMutation(\n  $input: DisableTeamsInput!\n) {\n  disableTeams(input: $input) {\n    company {\n      teamsEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "326fa2d6b66ca2ac12d893c3a9b0db07";

export default node;
